/** @format */

import TextUtil from './text_util'
import { env } from '../state/env'
import { ucooH5JumpApp as clientApp, ucooAlert, ucooSetTitleBar, callClientMethod } from './ucoowebview'

import { Native } from '../core/native'
const emptyCallback = function (result) {}
/**
 * 调用客户端API
 *
 * @param {String} eventName 事件名
 * @param {Object} data 参数
 * @param {Function} callback 结果回调对象
 */
function callNative(eventName, data, callback) {
  callClientMethod(eventName, JSON.stringify(data || {}), json => {
    //callback 不为空回调
    if (callback) {
      callback(JSON.parse(json))
    }
  })
}

const base_url = 'ucoo://page'

const client = {
  baseUrl: base_url,
  startUserProfileActivity(userid) {
    callNative(Native.UCOO_H5_JUMP_APP, {
      target_name: 'user_home',
      params: { user_id: `${userid}` },
    })
    console.log('startUserProfileActivity:', userid)
  },
  startTribeProfileActivity(tribeid) {
    callNative(Native.UCOO_H5_JUMP_APP, {
      target_name: `${base_url}/tribe_hall?tribe_id=${tribeid}`,
    })
    console.log('startTribeProfileActivity:', tribeid)
  },
  startDiamondStorePage() {
    callNative(Native.UCOO_H5_JUMP_APP, {
      target_name: `${base_url}/diamond_store`,
    })
    console.log('startDiamondStorePage:')
  },
  toast(msg) {
    if (!TextUtil.isNullOrEmpty(msg)) {
      ucooAlert(msg)
    } else {
      console.log('toast msg is null...')
    }
  },
  copy(text) {
    callNative(Native.COPY, { content: text })
  },
  finish() {
    callNative(Native.FINISH, {})
    console.log('call finish')
    this.goBack()
  },
  startChargeActivity() {
    callNative(Native.UCOO_H5_JUMP_APP, { target_name: 'recharge_coin' })
  },
  startVipActivity() {
    callNative(Native.UCOO_H5_JUMP_APP, { target_name: 'recharge_vip' })
  },
  startNativePage(link) {
    callNative(Native.UCOO_H5_JUMP_APP, { target_name: link })
    console.log('startNativePage:', link)
  },
  setTitle(title) {
    ucooSetTitleBar(title)
  },
  registerRoomMessageListener() {
    callClientMethod('register_room_event_listener', JSON.stringify({}), emptyCallback)
  },
  unregisterRoomMessageListener() {
    callClientMethod('unregister_room_event_listener', JSON.stringify({}), emptyCallback)
  },
  /**
   *
   * @param {String} eventName
   * @param {String} data Json String
   * @param {Function} callback data json
   */
  call(eventName, data, callback) {
    callClientMethod(eventName, data, callback)
  },
  callNative,
  goBack() {
    let state = window.history.state
    // if (env.debug) {
    console.log('================BACK==================')
    console.log('history length:', history.length)
    console.log('history state:', JSON.stringify(state))
    console.log('location:', JSON.stringify(window.location))
    console.log('=======================================')
    // }

    if (history.length > 1) {
      let forceFinish = state == null || (state.current && state.position != null && state.position == 0)
      if (forceFinish) {
        this.finish()
        return
      }
      history.back()
    } else {
      this.finish()
    }
  },
}

export { client as default }
